// extracted by mini-css-extract-plugin
module.exports = {"cols":"IndicesIntro_cols__Xepkr","title":"IndicesIntro_title__sS5OU","content":"IndicesIntro_content__6CFl2"};